import { render } from "./DansukTrello.vue?vue&type=template&id=79514c54&scoped=true"
import script from "./DansukTrello.vue?vue&type=script&lang=js"
export * from "./DansukTrello.vue?vue&type=script&lang=js"

import "./DansukTrello.vue?vue&type=style&index=0&id=79514c54&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79514c54"]])

export default __exports__